import { Dto, DtoWithId } from "@mango/core";
import { Instrument } from "./instrument";


@Dto({fullName: "CIJBorculo.Logic.OproepHistorie"})
export class OproepHistorie extends DtoWithId {
	instrument: Instrument;
	naam: string;
	contact: string;
	eMail: string;
	soort: string;
	merk: string;
	type: string;
	datumKalibratie: Date;
	datumOproep: Date;
	datumMail: Date;
	datumBinnenkomst: Date;
	oproepen:boolean;
	herOproepen:boolean;
	jaarMail: number;
	weeknummerMail: string;
}